/// <reference path="./@types/vue.d.ts" />

import { ofType } from 'vue-tsx-support';

import NoServerRendering from './no-ssr.vue';

const noServerRenderingTs = ofType().convert(NoServerRendering);

export { noServerRenderingTs as NoServerRendering };
